export default "__VITE_ASSET__Dwaxn1By__"